export const getHrefFromGuide = (guide, path) => {
    const sanitizedCity = guide?.city_slug
        ?.replace(' ', '-')
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, '')
        ?.toLowerCase()
    return `/${path}/${sanitizedCity}/${guide.slug}`
}

export const getTourPath = (tour, pathguide) => {
    if (tour.type === 'city') return getCityPath(tour);
    if (tour.type === undefined) return getHrefFromGuide(tour, pathguide);
    const sanitizedCity = tour?.city_slug
        ?.replace(' ', '-')
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, '')
        ?.toLowerCase()
    return `/tour/${sanitizedCity}/${tour.slug}`
}

export const getCityPath = (tour, pathguide) => {
    if (tour.type === undefined) return getHrefFromGuide(tour, pathguide);
    const sanitizedCity = tour?.city_slug
        ?.replace(' ', '-')
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, '')
        ?.toLowerCase()
    return `/tours/${sanitizedCity}`
}